var map = {
	"./academic.svg": "61d0",
	"./arrow.svg": "d4d9",
	"./circuit.svg": "ff70",
	"./close.svg": "bb7c",
	"./convenient.svg": "8f09",
	"./copy.svg": "b420",
	"./diamonds.svg": "1c5f",
	"./download.svg": "8215",
	"./global.svg": "5ba4",
	"./group.svg": "df55",
	"./lap.svg": "e33c",
	"./lock.svg": "3b18",
	"./recommend.svg": "cabb",
	"./satisfy.svg": "56af",
	"./search.svg": "0a17",
	"./trend.svg": "31fc",
	"./upload.svg": "cdcb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";